module.exports = __webpack_public_path__ + "img/244.31cdfe79.png";